import React, { useState, useEffect } from "react";
import { Grid, Typography, Box, TextField, Select, MenuItem } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import InputForm from "./_input-form";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import { useTranslation } from "react-i18next";
import { ticketService } from '../../model/_service';

const DropDown = withStyles((theme) => ({
  root: {
    padding: "0.46rem  !important",
    fontSize: "0.75rem !important",
  },
}))(Select);


const useStyles = makeStyles((theme) => ({
  blueColor: {
    color: theme.palette.ePrimary.base,
  },
  secondaryColor: {
    color: theme.palette.ePrimary.base + " !important",
  },
  radioPadding: {
    padding: 2,
    paddingLeft: "0.625rem"
  },
  displayInline: {
    display: "inline",
    marginRight: 10
  },
  defaultColor: {
    color: theme?.palette?.eMedium?.base + "!important",
  },
  paddingBottomRadio: {
    paddingBottom: 4
  }
}));

export default function PremiseDetails(props) {
  const { divisionList, 
    districtPremise, address1Premise, address2Premise, postOfficePremise, divisionPremise, countryPremise, postCodePremise, thanaPremise,
    setDistrictPremise, setAddress1Premise, setAddress2Premise, setPostOfficePremise, setDivisionPremise, setDivisionCodePremise, setCountryPremise, setPostCodePremise, setThanaPremise,
    sameAsPremiseCheck, setStateCode, connectionOnExistingPremise, setconnectionOnExistingPremise,
    premiseType, setpremiseType, premiseCategory, setpremiseCategory, showConnectionOnExistingPremise, setpremiseTypeCode, setpremiseCategoryCode,existingPremisesList,
    setexistingPremiseID,
    existingPremiseValue,
    setexistingPremiseValue,
    sndValue,setSndValue,
    sndCode,setSndCode,districtdropdown, setdistrictdropdown,thanadropdown, setthanadropdown
 
  } = props;
  let classes = useStyles();
  let labels = useSelector(
    (store) => store?.labels?.data?.getLabels?.E_PREMISE_DETAILS
  );
  const { t: premiseLabel } = useTranslation("label-E_PREMISE_DETAILS");
  const { t: applicantLabels } = useTranslation("label-E_APPLICANT_DETAILS");

  const languageCode = useSelector((store) => store?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE);

  const [premiseTypeList, setpremiseTypeList] = useState([]);
  const [premiseCategoryList, setpremiseCategoryList] = useState([]);

  const dropDownMenuProps = {
    disableScrollLock: false,
    anchorOrigin: {
      vertical: "bottom"
    },
    transformOrigin: {
      vertical: "top"
    },
    getContentAnchorEl: null
  }

  useEffect(() => {
    if (languageCode) {
      ticketService
        .getDropdownpData("E_PREMISE_TYPES", languageCode)
        .then((res) => {
          setpremiseTypeList(res?.data?.data?.getDropdownData);
        })
        .catch(() => {
          setpremiseTypeList(null);
        });

      ticketService
        .getDropdownpData("E_PREMISE_CATEGORY", languageCode)
        .then((res) => {
          setpremiseCategoryList(res?.data?.data?.getDropdownData);
        })
        .catch(() => {
          setpremiseCategoryList(null);
        });
    }
  }, [languageCode]);
  function alphabeticalOrder(arr) {
    return arr && arr?.sort((a, b) => a.dropDownValue < b.dropDownValue ? -1 : 1)
  }
  useEffect(()=>{
    alphabeticalOrder(premiseCategoryList)
  },[premiseCategoryList])
  const handleRadioChange = (e) => {
    setconnectionOnExistingPremise(e.target.value)
    if (e.target.value == "no") {
      setexistingPremiseID("")
      setexistingPremiseValue("")
      setAddress1Premise("")
      setAddress2Premise("")
      setThanaPremise("")
      setDistrictPremise("")
      setPostOfficePremise("")
      setDivisionPremise("")
      setPostCodePremise("")
      setSndValue("")
      setSndCode("")
    }
  }
  const handlePremiseTypeChange = (e) => {
    setpremiseType(e.target.value)
    premiseTypeList.map((item) => {
      if(item?.dropDownValue === e.target.value) {
        setpremiseTypeCode(item?.dropDownCode);
      }
    })
  }
  const handlePremiseCategoyChange = (e) => {
    setpremiseCategory(e.target.value)
    premiseCategoryList.map(item => {
      if(item?.dropDownValue === e.target.value) {
        setpremiseCategoryCode(item?.dropDownCode);
      }
    })
  }
  const handlePremise = (e) => {
    const selectedPremise = existingPremisesList.find(premise => premise.premId === e.target.value);
    setexistingPremiseID(selectedPremise.premId)
    const division = divisionList?.find(item => item?.dropDownCode === selectedPremise.division)?.dropDownValue;
    setexistingPremiseValue(selectedPremise.address1+", "+selectedPremise.address2+", "+selectedPremise.thanaUpzilla+", "+selectedPremise.district+", "+selectedPremise.sndValue+", "+selectedPremise.postOffice+", "+division+", "+selectedPremise.postCode)
    setAddress1Premise(selectedPremise.address1)
    setAddress2Premise(selectedPremise.address2)
    setThanaPremise(selectedPremise.thanaUpzilla)
    setDistrictPremise(selectedPremise.district)
    setPostOfficePremise(selectedPremise.postOffice)
    setDivisionPremise(division)
    setDivisionCodePremise(selectedPremise.division)
    setPostCodePremise(selectedPremise.postCode)
    setSndValue(selectedPremise.sndValue)
  }
  const [SndInConnection , setSndInConnection] = useState(true)
  return (
    <Grid container spacing={0}>
      {showConnectionOnExistingPremise && <Grid item xs={12} className={classes.paddingBottomRadio}>
        <Typography variant="subtitle2" className={[classes.secondaryColor, classes.displayInline]}>
          <b>{premiseLabel("E_PREMISE_CONNECTION_ON_EXISTING_PREMISE")}</b>
        </Typography>
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="gender"
            row
            name="uniqueRadioValue"
            value={connectionOnExistingPremise}
            onChange={handleRadioChange}
          >
            <FormControlLabel
              value="yes"
              control={<Radio className={[classes.secondaryColor, classes.radioPadding]} />}
              label={applicantLabels("E_APPLICANT_YES")}
            />
            <FormControlLabel
              value="no"
              control={<Radio className={[classes.secondaryColor, classes.radioPadding]} />}
              label={applicantLabels("E_APPLICANT_NO")}
            />
          </RadioGroup>
        </FormControl>
      </Grid>}
      {showConnectionOnExistingPremise && connectionOnExistingPremise == "yes" && <Grid item xs={12} className={classes.paddingBottomRadio}>
        <Grid container>
          <Grid item xs={12} sm={6}>
            <Box px={1}>
              <Grid container spacing={1} direction="row">
                <Grid item xs={12}>
                  <Typography variant="caption">
                    <Box pb={0.2}>
                      {premiseLabel("E_PREMISE_PREMISE")}<span className={classes.asterisk}>*</span>
                    </Box>
                  </Typography>
                  <DropDown
                    fullWidth
                    variant="outlined"
                    labelId="label"
                    id="select"
                    value={existingPremiseValue}
                    onChange={handlePremise}
                    renderValue={(selected) => {
                      if (selected?.length == 0) {
                        return premiseLabel("E_PREMISE_PREMISE_PLACEHOLDER")
                      }
                      return selected;
                    }}
                    displayEmpty
                    MenuProps={dropDownMenuProps}
                  >
                    {existingPremisesList?.length && existingPremisesList?.map((item, k) => {
                      return (
                        <MenuItem value={item.premId}>
                          {item.address1+", "+item.address2+", "+item.thanaUpzilla+", "+item.district+", "+item.postOffice+", "+divisionList?.find(div => div.dropDownCode === item.division)?.dropDownValue+", "+item.postCode}
                        </MenuItem>
                      );
                    })}
                  </DropDown>
                  <div>&nbsp;</div>
                </Grid>
              </Grid>
            </Box>
          </Grid>

        </Grid>
      </Grid>}
      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={12} sm={6}>
            <Box px={1}>
              <Grid container spacing={1} direction="row">
                <Grid item xs={12}>
                  <Typography variant="caption">
                    <Box pb={0.2}>
                      {premiseLabel("E_PREMISE_PREMISE_TYPE")}
                    </Box>
                  </Typography>
                  <DropDown
                    fullWidth
                    variant="outlined"
                    labelId="label"
                    id="select"
                    value={premiseType}
                    className={!premiseType && classes.defaultColor}
                    onChange={handlePremiseTypeChange}
                    renderValue={(selected) => {
                      if (selected?.length == 0) {
                        return premiseLabel("E_PREMISE_SELECT") + " " + premiseLabel("E_PREMISE_PREMISE_TYPE")
                      }
                      return selected;
                    }}
                    displayEmpty
                    MenuProps={dropDownMenuProps}
                  >
                    {premiseTypeList?.length && premiseTypeList?.map((item, k) => {
                      return (
                        <MenuItem value={item.dropDownValue}>
                          {item.dropDownValue}
                        </MenuItem>
                      );
                    })}
                  </DropDown>
                  <div>&nbsp;</div>
                </Grid>
              </Grid>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box px={1}>
              <Grid container spacing={1} direction="row">
                <Grid item xs={12}>
                  <Typography variant="caption">
                    <Box pb={0.2}>
                      {premiseLabel("E_PREMISE_PREMISE_CATEGORY")}
                    </Box>
                  </Typography>
                  <DropDown
                    fullWidth
                    variant="outlined"
                    labelId="label"
                    id="select"
                    value={premiseCategory}
                    className={!premiseCategory && classes.defaultColor}
                    onChange={handlePremiseCategoyChange}
                    renderValue={(selected) => {
                      if (selected?.length == 0) {
                        return premiseLabel("E_PREMISE_SELECT") + " " + premiseLabel("E_PREMISE_PREMISE_CATEGORY")
                      }
                      return selected;
                    }}
                    displayEmpty
                    MenuProps={dropDownMenuProps}
                  >
                    {premiseCategoryList?.length && premiseCategoryList?.map((item, k) => {
                      return (
                        <MenuItem value={item.dropDownValue}>
                          {item.dropDownValue}
                        </MenuItem>
                      );
                    })}
                  </DropDown>
                  <div>&nbsp;</div>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      {(!showConnectionOnExistingPremise || connectionOnExistingPremise != "yes") && <Grid item xs={12}>
        <Box pb={2}>
          <Typography variant="subtitle2" className={classes.blueColor}>
            <b>{premiseLabel("E_PREMISE_CONNECTION_ADDRESS")}</b>
          </Typography>
        </Box>
        <InputForm
        districtdropdown={districtdropdown}
        setdistrictdropdown={setdistrictdropdown}
        thanadropdown={thanadropdown}
         setthanadropdown={setthanadropdown}
          divisionList={divisionList}
          district={districtPremise}
          address1={address1Premise}
          address2={address2Premise}
          postOffice={postOfficePremise}
          setStateCode={setStateCode}
          division={divisionPremise}
          country={countryPremise}
          postcode={postCodePremise}
          thana={thanaPremise}
          setThana={setThanaPremise}
          setDistrict={setDistrictPremise}
          setAddress1={setAddress1Premise}
          setAddress2={setAddress2Premise}
          setPostOffice={setPostOfficePremise}
          setDivision={setDivisionPremise}
          setDivisionCode={setDivisionCodePremise}
          setCountry={setCountryPremise}
          setPostCode={setPostCodePremise}
          sndCode={sndCode}
          setSndCode={setSndCode}
          sndValue={sndValue}
          setSndValue={setSndValue}
          SndInConnection={SndInConnection}
        ></InputForm>
      </Grid>}
    </Grid>
  );
}